import React, { lazy } from 'react'
import { useAtSize } from '@fs/zion-ui'

const ResponsiveYoutubeVideo = lazy(() => import('./ResponsiveYoutubeVideo'))
const BitmovinPlayer = lazy(() => import('./../eden-bitmovin-player/src/index'))

const VideoSwitcher = ({ videoProvider, smallBrightcoveSize = false, noMinHeight, autoSelectedLanguage, title }) => {
  const widths = !smallBrightcoveSize
    ? { default: 300, sm: 400, lg: 700, xxl: 1000 }
    : { default: 300, sm: 400, xxl: 700 }

  const heights = !smallBrightcoveSize
    ? { default: 168, sm: 225, lg: 394, xxl: 563 }
    : { default: 168, sm: 225, xxl: 394 }

  const videoProviderType = videoProvider?.providerType
  const atSize = useAtSize()
  return (
    <>
      {videoProviderType === 'brightcove' && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <BitmovinPlayer
            autoplay
            autoSelectedLanguage={autoSelectedLanguage}
            videoData={{
              videoID: videoProvider?.videoId,
              account: videoProvider?.accountId,
            }}
            width={atSize(widths)}
            height={atSize(heights)}
            title={title}
          />
        </div>
      )}
      {videoProviderType === 'youtube' && (
        <ResponsiveYoutubeVideo youTubeId={videoProvider?.videoId} noMinHeight={noMinHeight} title={title} />
      )}
    </>
  )
}

export default VideoSwitcher
